(() => {
  const DELAY = 5000;

  function startFor(comp) {
    if (comp.__autoTimer) return;

    comp.__autoTimer = setInterval(() => {
      if (document.hidden) return;

      // 1) Si Swiper API existe
      const swiper = comp.querySelector(".swiper")?.swiper;
      if (swiper && !swiper.destroyed) {
        swiper.isEnd ? swiper.slideTo(0, 0) : swiper.slideNext(500);
        return;
      }

      // 2) Fallback: click en bullets
      const bullets = comp.querySelectorAll(".swiper-pagination-bullet");
      if (!bullets.length) return;

      let active = -1;
      bullets.forEach((b, i) => {
        if (b.classList.contains("swiper-pagination-bullet-active")) active = i;
      });

      bullets[(active + 1) % bullets.length].click();
    }, DELAY);
  }

  function boot() {
    if (!location.pathname.includes("/pages/distribuidores")) return;

    document
      .querySelectorAll("swiper-component.collection-carousel-swiper-component")
      .forEach(startFor);
  }

  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
  new MutationObserver(boot).observe(document.documentElement, { childList: true, subtree: true });
})();
